const siteConfig = {
  site: {
    name:     'Your Change Mentor',
    shortName: 'YCM',
    url:      'https://yourchangementor.com',
  },

  contact: {
    email:     'tamara.bonilla@yourchangementor.com',
    linkedin:  'https://www.linkedin.com/in/tamara-bonilla',
    instagram: 'https://www.instagram.com/yourchangementor',
  },

  bookingUrl: process.env.REACT_APP_BOOKING_URL || '', // Google Calendar appointment scheduling link

  webhookUrl: process.env.REACT_APP_WEBHOOK_URL || '', // Form -> Google Sheets + Flodesk via Apps Script

  newsletterUrl: 'https://www.linkedin.com/newsletters/7289022571964977152/',

  sections: {
    hero:        {enabled: true,  order: 1},
    problem:     {enabled: true,  order: 2},
    about:       {enabled: true,  order: 3},
    methodology: {enabled: true,  order: 4},
    services:    {enabled: true,  order: 5},
    results:     {enabled: false, order: 6},
    leadCapture: {enabled: true,  order: 7},
    podcast:     {enabled: true,  order: 7.5},
    faq:         {enabled: true,  order: 8},
    whyNow:      {enabled: false, order: 9},
  },

  features: {
    cookieConsent:   true,
    analytics:       true,
    bookingEmbed:    false,
    emailAutomation: false,
    eventModal:      true,
  },

  analytics: {
    ga4Id:             process.env.REACT_APP_GA4_ID || '',
    linkedInPartnerId: process.env.REACT_APP_LINKEDIN_PARTNER_ID || '',
    clarityId:         process.env.REACT_APP_CLARITY_ID || '',
  },
};

export default siteConfig;
